import planningService from "../../services/planning"

export default {
  namespaced: true,
  state: {
    modifications: []
  },
  mutations: {
    REFRESH(state, modifications) {
      state.modifications = modifications
    }
  },
  actions: {
    REFRESH: async(context) => {
      const modifications = await planningService.getModificationRequests().then(
        response => response.success ? response.data : []
      ).catch(
        () => []
      )
      context.commit("REFRESH", modifications)
    },
    EDIT: async (context, payload) => {
     let isEdited = await planningService.editPlanning(payload).then(
        response => response.success
      )
      if (isEdited) {
        context.dispatch("refresh")
      }
      return isEdited
    },
    CANCEL: async (context, pk) => {
      const isCancelled = await planningService.deleteModificationRequests(pk).then(
        response => response.success
      ).catch(
        () => false
      )
      if (isCancelled) {
        context.dispatch("refresh")
      }
      return isCancelled
    }
  },
  getters: {
    modifications: state => state.modifications
  }
}
